import $config from 'config'

function formatServiceMinutes (value, type) {
  let result = '{id}'.format(+value % 60)
  let text = ' 分钟'
  if (value > 59) {
    result = '{id}'.format(Math.floor((+value / 60)))
    text = ' 小时'
  }
  if (!type) {
    result += text
  }
  return result
}

function formatImage (value, type) {
  // 定义了3种样式图片 169 代表 16:9 , 43 代表 4:3 , 11 代表 1:1
  // 每种共三个大小 s 代表 small , m 代表 middle ,b 代表 big
  // 共有9种图片 b169 m169 s169 b43 m43 s43 b11 m11 s11
  // 还有不传参数代表原图
  if (/^https?:\/\//.test(value)) {
    return value
  }
  if (/^data:image/.test(value)) {
    return value
  }
  if (!value) {
    value = 'default.png'
  }
  if (type) {
    return $config.imageUrl + value + '-' + type
  } else {
    return $config.imageUrl + value
  }
}

function formatPreViewer (value) {
  if (!value) return ''
  let jsonStr = {
    src: value,
    w: 800,
    h: 600
  }
  return jsonStr
}

function formatContent (value) {
  if (!value) return ''
  return value.replace(/\n/gi, '<br/>').replace(/ /gi, '&nbsp')
}
function formatError (value, content) {
  if (!value) return ''
  return value.replace('%%%', content)
}
// time format method
function formatDate (time, type) {
  if (!time) time = new Date()
  if (/^\d+$/.test(time)) time = new Date(time)
  if (!(time instanceof Date)) time = new Date(time)
  var month = time.getMonth() + 1
  if (month < 10) {
    month = '0' + month
  }
  var day = time.getDate()
  if (day < 10) {
    day = '0' + day
  }
  var hour = time.getHours()
  if (hour < 10) {
    hour = '0' + hour
  }
  var minute = time.getMinutes()
  if (minute < 10) {
    minute = '0' + minute
  }
  if (type === 1) {
    return '{id}-{id}{id}{id}:{id}'.format(month, day, ' ', hour, minute)
  } else if (type === 2) {
    return '{id}-{id}-{id}'.format(time.getFullYear(), month, day)
  } else if (type === 5) {
    return '{id}年{id}月{id}日'.format(time.getFullYear(), month, day)
  } else {
    return '{id}-{id}-{id}{id}{id}:{id}'.format(time.getFullYear(), month, day, ' ', hour, minute)
  }
}

function isEmptyObject (e) {
  var t
  for (t in e) {
    return !1
  }
  return !0
}

function interval (func, wait) {
  var interv = function () {
    func.call(null) // eslint-disable-line
    setTimeout(interv, wait)
  }
  setTimeout(interv, wait)
}

function formatSalary([min = 0, max = 0], type = 0) {
  // 转为 nk-nk格式
  let template // 格式化模版
  if (min === max && max === 0) {
    return '未知'
  }
  if (type === 0) {
    template = '{id}K-{id}K'
  }
  if (min === -1 && max === -1) {
    return '不限'
  }
  if (!min) {
    return max / 1000 + 'K以下'
  }
  if (!max) {
    return min / 1000 + 'K以上'
  }
  return template.format(min / 1000, max / 1000)
}

export { formatServiceMinutes, formatError, formatImage, formatPreViewer, formatContent, formatDate, isEmptyObject, interval, formatSalary }



// WEBPACK FOOTER //
// ./src/common/utils/common-methods.js